import { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";

import { saveSettings, getSettings } from "../../services/settingsService";

import "./Settings.css";

import { storage } from "../../firebase/config";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { auth } from "../../firebase/config";

export default function Settings() {
  const [formData, setFormData] = useState({
    gymName: "",
    ownerName: "",
    phone: "",
    email: "",
    address: "",
    logo: "",
    logoBase64: "",
  });

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const data = await getSettings();

      if (data) {
        setFormData({
          gymName: data.gymName || "",
          ownerName: data.ownerName || "",
          phone: data.phone || "",
          email: data.email || "",
          address: data.address || "",
          logo: data.logo || "",
          logoBase64: data.logoBase64 || "",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = async () => {
    // Validation
    if (!(formData.gymName || "").trim()) {
      alert("Please enter Gym Name");
      return;
    }

    if (!(formData.ownerName || "").trim()) {
      alert("Please enter Owner Name");
      return;
    }

    if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      alert("Please enter a valid 10-digit Phone Number");
      return;
    }

    if (!(formData.email || "").trim()) {
      alert("Please enter Email Address");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(formData.email)) {
      alert("Please enter a valid Email Address");
      return;
    }

    if (!formData.logo) {
      alert("Please upload Gym Logo");
      return;
    }

    if (!(formData.address || "").trim()) {
      alert("Please enter Gym Address");
      return;
    }

    try {
      await saveSettings(formData);

      alert("Settings Saved Successfully");
    } catch (error) {
      console.error(error);
      alert("Failed to Save Settings");
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result);

      reader.onerror = (error) => reject(error);
    });
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // Maximum 1 MB
    const MAX_LOGO_SIZE = 1 * 1024 * 1024;

    if (file.size > MAX_LOGO_SIZE) {
      alert("Gym Logo size must be less than 1 MB.");
      return;
    }

    // Allowed image types
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];

    if (!allowedTypes.includes(file.type)) {
      alert("Only PNG, JPG, JPEG and WEBP images are allowed.");
      return;
    }

    try {
      const storageRef = ref(
        storage,
        `gymLogos/${auth.currentUser.uid}/${Date.now()}_${file.name}`,
      );

      await uploadBytes(storageRef, file);

      const downloadURL = await getDownloadURL(storageRef);
      // Convert uploaded image to Base64
      const logoBase64 = await convertToBase64(file);

      setFormData((prev) => ({
        ...prev,
        logo: downloadURL,
        logoBase64: logoBase64,
      }));

      alert("Logo uploaded successfully.");
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <div className="settings-container">
        {/* Header */}

        <div className="settings-header">
          <div>
            <h1>Gym Settings</h1>

            <p style={{ fontWeight: "bold", color: "white" }}>
              Manage your gym profile, contact information, branding and
              business details.
            </p>
          </div>

          <div className="settings-badge">Gym Profile</div>
        </div>

        {/* Main Card */}

        <div className="settings-card">
          <div className="card-title">
            <h2>Business Information</h2>

            <p>Update your gym information and branding details.</p>
          </div>

          <div className="settings-grid">
            {/* Gym Name */}

            {/* <div className="form-group">
              <label>Gym Name</label>

              <input
                type="text"
                name="gymName"
                placeholder="Enter Gym Name"
                value={formData.gymName}
                onChange={handleChange}
                required
              />
            </div> */}

            <div className="form-group">
              <label>Gym Name</label>

              <input
                type="text"
                name="gymName"
                value={formData.gymName}
                readOnly
                className="readonly-input"
              />
            </div>

            {/* Owner Name */}

            <div className="form-group">
              <label>Owner Name</label>

              <input
                type="text"
                name="ownerName"
                placeholder="Enter Owner Name"
                value={formData.ownerName}
                onChange={handleChange}
                required
              />
            </div>

            {/* Phone */}

            <div className="form-group">
              <label>Phone Number</label>

              <input
                type="text"
                name="phone"
                placeholder="Enter Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            {/* Email */}

            {/* <div className="form-group">
              <label>Email Address</label>

              <input
                type="email"
                name="email"
                placeholder="Enter Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div> */}

            <div className="form-group">
              <label>Email Address</label>

              <input
                type="email"
                name="email"
                value={formData.email}
                readOnly
                className="readonly-input"
              />
            </div>

            {/* Logo URL */}

            <div className="form-group full-width">
              <label>Gym Logo URL</label>

              <input
                type="file"
                accept=".png,.jpg,.jpeg,.webp,.svg"
                onChange={handleLogoUpload}
              />
            </div>

            {/* Address */}

            <div className="form-group full-width">
              <label>Address</label>

              <textarea
                name="address"
                placeholder="Enter Gym Address"
                value={formData.address}
                onChange={handleChange}
                required
              ></textarea>
            </div>
          </div>

          {/* Logo Preview */}

          {formData.logo && (
            <div className="logo-preview">
              <img src={formData.logo} alt="Gym Logo" />
            </div>
          )}

          {/* Save Button */}

          <button className="save-btn" onClick={handleSave}>
            Save Settings
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
}
